import createSvgIcon from "./utils/create_icon"

const PlusLarge = createSvgIcon(<path d="M19 12a1 1 0 0 1-1 1h-5v5a1 1 0 1 1-2 0v-5H6a1 1 0 1 1 0-2h5V6a1 1 0 1 1 2 0v5h5a1 1 0 0 1 1 1z" fill="currentColor" />, "PlusLarge")
export default PlusLarge
